export class CartViews {
    constructor(eventEmitter, onRemove) {
        this.eventEmitter = eventEmitter;
        this.onRemove = onRemove;
        this.template = document.querySelector('#basket');
        this.cardTemplate = document.querySelector('#card-basket');
        this.basketButton = document.querySelector('.header__basket');
        this.basketCounter = this.basketButton.querySelector('.header__basket-counter');
        this.basketButton.addEventListener('click', () => {
            this.eventEmitter.emit('cart:open');
        });
        this.updateCounter(0);
    }
    render(state) {
        // Обновляем счетчик корзины
        this.updateCounter(state.items.length);
        // Клонируем шаблон корзины
        const basket = this.template.content.cloneNode(true);
        const list = basket.querySelector('.basket__list');
        const total = basket.querySelector('.basket__price');
        const button = basket.querySelector('.basket__button');
        // Очищаем список
        list.innerHTML = '';
        // Добавляем каждый товар
        state.items.forEach((item, index) => {
            const itemElement = this.cardTemplate.content.cloneNode(true);
            const itemCard = itemElement.querySelector('.basket__item');
            const indexElement = itemCard.querySelector('.basket__item-index');
            if (indexElement) {
                indexElement.textContent = (index + 1).toString();
            }
            const titleElement = itemCard.querySelector('.card__title');
            if (titleElement) {
                titleElement.textContent = item.product.title;
            }
            const priceElement = itemCard.querySelector('.card__price');
            if (priceElement) {
                priceElement.textContent = item.product.price ? `${item.product.price} синапсов` : 'Бесценно';
            }
            const deleteButton = itemCard.querySelector('.basket__item-delete');
            if (deleteButton) {
                deleteButton.addEventListener('click', (e) => {
                    e.stopPropagation();
                    this.onRemove(item.product);
                });
            }
            list.appendChild(itemCard);
        });
        // Устанавливаем общую сумму
        if (total) {
            total.textContent = `${state.totalPrice} синапсов`;
        }
        // Активируем/деактивируем кнопку оформления заказа
        if (button) {
            button.disabled = state.items.length === 0;
            const submitHandler = () => {
                this.eventEmitter.emit('order:submit');
            };
            button.addEventListener('click', submitHandler, { once: true });
        }
        return basket;
    }
    updateCounter(count) {
        if (this.basketCounter) {
            this.basketCounter.textContent = count.toString();
            this.basketCounter.style.display = count > 0 ? 'flex' : 'none';
        }
    }
}
